import type React from 'react'

const PIXEL_ID = '1053265711091258'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
    }
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    window.fbq = n

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const first = document.getElementsByTagName('script')[0]
    if (first && first.parentNode) {
      first.parentNode.insertBefore(script, first)
    } else {
      document.head.appendChild(script)
    }

    window.fbq('init', PIXEL_ID)
  }

  window.fbq('track', 'PageView')
}

export function trackMetaEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params)
  }
}

/**
 * Fires a Meta event and only then follows the link, so the beacon is not
 * cancelled by the navigation. Falls back to navigating immediately if the
 * pixel is unavailable.
 */
export function trackAndNavigate(
  eventObject: React.MouseEvent<HTMLAnchorElement>,
  url: string,
  event: string,
  params?: Record<string, unknown>,
): void {
  // Let the browser handle new-tab / modified clicks natively.
  if (
    eventObject.defaultPrevented ||
    eventObject.metaKey ||
    eventObject.ctrlKey ||
    eventObject.shiftKey ||
    eventObject.altKey ||
    eventObject.button !== 0
  ) {
    trackMetaEvent(event, params)
    return
  }

  eventObject.preventDefault()
  trackMetaEvent(event, params)

  let navigated = false
  const go = () => {
    if (navigated) return
    navigated = true
    window.location.href = url
  }

  // Give fbevents.js a moment to send the request, but never block the user.
  window.setTimeout(go, 350)
}
